import {adbApi} from "./adbService";

export const procurementApi = adbApi.injectEndpoints({
	endpoints: (builder) => ({
		getProcurementPackage: builder.query({
			query: ({isAllPackages, search, per_page, page}) => ({
				url: `procurement-package?all_projects=${isAllPackages}
                ${search ? `&search=${search}` : ''}
                ${per_page ? `&per_page=${per_page}` : ''}
                ${page ? `&page=${page}` : ''}`,
				method: 'GET',
			}),
			providesTags: ["ProcurementPackage"],
		}),
		getProcurementPackageById: builder.query({
			query: ({id}) => ({
				url: `procurement-package/dashboard/${id}`,
				method: 'GET',
			}),
			invalidatesTags: ["ProcurementPackage"],
		}),
		getProcurementPackageDashboard: builder.query({
			query: () => ({
				url: `pages/procurement-package/dashboard`,
				method: 'GET',
			}),
			invalidatesTags: ["ProcurementPackage"],
		}),
		createProcurementPackage: builder.mutation({
			query: (body) => ({
				url: `procurement-package`,
				method: 'POST',
				body
			}),
			invalidatesTags: ["ProcurementPackage"],
		}),
		updateProcurementPackage: builder.mutation({
			query: ({reportId, body}) => ({
				url: `procurement-package/${reportId}`,
				method: 'POST',
				body
			}),
			invalidatesTags: ["ProcurementPackage"],
		}),
		deleteProcurementPackage: builder.mutation({
			query: (packageId) => ({
				url: `procurement-package/${packageId}`,
				method: 'DELETE',
			}),
			invalidatesTags: ["ProcurementPackage"],
		}),
		getCreateProcurementPTranslations: builder.query({
			query: (body) => ({
				url: `pages/procurement-package/edit`,
				method: 'GET',
				body
			}),
		}),
		getProcurementReportSections: builder.query({
			query: () => ({
				url: 'procurement-package/report/sections',
				method: 'GET',
			}),
			providesTags: ["ProcurementPackage"],
		}),
		getProcurementTranslationsList: builder.query({
			query: () => ({
				url: "pages/procurement-package/list",
				method: 'GET',
			})
		}),
		getDetailsProcurementTranslationsList: builder.query({
			query: () => ({
				url: "pages/procurement-package/details",
				method: 'GET',
			})
		}),
		getMilestoneList: builder.query({
			query: (id) => ({
				url: `procurement-package/milestones/list/${id}`,
				method: 'GET',
			})
		}),
		getReport: builder.query({
			query: (id) => ({
				url: `procurement-package/report/${id}`,
				method: 'GET',
			})
		}),
		removeMilestone: builder.query({
			query: (id) => ({
				url: `procurement-package/milestones/delete/${id}`,
				method: 'DELETE',
			})
		}),
		createMilestone: builder.query({
			query: (body) => ({
				url: `procurement-package/milestones/create`,
				method: 'POST',
				body
			})
		}),
		updateMilestone: builder.query({
			query: (body) => ({
				url: `procurement-package/milestones/update/${body?.id}`,
				method: 'POST',
				body
			})
		}),
		getMilestoneDocuments: builder.query({
			query: (id) => ({
				url: `procurement-package/documents/list/${id}`,
				method: 'GET',
			})
		}),
		addMilestoneDocument: builder.query({
			query: (body) => ({
				url: `procurement-package/documents/create`,
				method: 'POST',
				body
			})
		}),
		getPackageMonitoringFilter: builder.query({
			query: (params) => ({
				url: `procurement-package-monitoring/filter`,
				method: 'GET',
				params
			})
		}),
		getPackageMonitoring: builder.query({
			query: (params) => ({
				url: `procurement-package-monitoring`,
				method: 'GET',
				params
			})
		}),
		getSubmittedReportsProcurement: builder.query({
			query: (package_id) => {
				return {
					url: `procurement-package/submitted-reports/${package_id}`,
					method: 'GET',
				}
			}
		}),
		procurementPackageReportSubmit: builder.query({
			query: (reportId) => ({
				url: `procurement-package/report/submit/${reportId}`,
				method: 'POST',
			})
		}),
	}),
	overrideExisting: false,
});

export const {
	useLazyGetProcurementPackageQuery,
	useLazyGetProcurementPackageByIdQuery,
	useGetProcurementPackageDashboardQuery,
	useCreateProcurementPackageMutation,
	useUpdateProcurementPackageMutation,
	useDeleteProcurementPackageMutation,
	useLazyGetProcurementReportSectionsQuery,
	useLazyGetCreateProcurementPTranslationsQuery,
	useLazyGetProcurementTranslationsListQuery,
	useLazyGetDetailsProcurementTranslationsListQuery,
	useLazyGetMilestoneListQuery,
	useLazyRemoveMilestoneQuery,
	useLazyCreateMilestoneQuery,
	useLazyUpdateMilestoneQuery,
	useLazyGetReportQuery,
	useLazyGetMilestoneDocumentsQuery,
	useLazyGetSubmittedReportsProcurementQuery,
	useLazyAddMilestoneDocumentQuery,
	useLazyGetPackageMonitoringFilterQuery,
	useLazyGetPackageMonitoringQuery,
	useLazyProcurementPackageReportSubmitQuery,
} = procurementApi;
